module.exports = __webpack_public_path__ + "img/198.appliance_problem.a79f137e.svg";